var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.text)?_c('v-chip',{style:(_vm.chipStyle),attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.formattedText)+" ")]):_c('span',{staticClass:"status-dot",style:(_vm.dotStyle)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }